'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bcGetSpm = require('@alife/bc-get-spm');

var _bcGetSpm2 = _interopRequireDefault(_bcGetSpm);

var _bcSafeLog = require('@alife/bc-safe-log');

var _bcSafeLog2 = _interopRequireDefault(_bcSafeLog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var elDlg = void 0; // 弹窗全局唯一
var spmObj = void 0;
var hideCallback = void 0;

function show(frameSrc, params, onHide) {
  spmObj = spmObj || (0, _bcGetSpm2['default'])() || {};

  var frameUrl = frameSrc + '&spm=' + spmObj.a + '.' + spmObj.b;
  params && Object.keys(params).forEach(function (key) {
    frameUrl = frameUrl + '&' + key + '=' + encodeURIComponent(String(params[key]));
  });

  (0, _bcSafeLog2['default'])('/sc.customize.openApi', 'EXP', 'type=edit&scene=' + spmObj.a + '.' + spmObj.b + '&method=' + (window.innerWidth < 960 ? 'newtab' : 'dialog'));

  // 弹窗最小尺寸800，需要父容器宽度至少960，否则直接新窗口打开
  if (window.innerWidth < 960) {
    window.open(frameUrl);
    return;
  }

  hide();

  elDlg = document.createElement('div');
  elDlg.setAttribute('class', 'bc-customize-dialog');

  elDlg.innerHTML = '\n    <div class="bcd-wrap">\n      <div class="bcd-con">\n        <div class="bcd-close">\n          <i class="next-icon next-icon-close next-icon-large next-large"></i>\n        </div>\n        <div class="bcd-loading">\n          <i class="next-icon next-icon-loading next-icon-xxl next-xxl"></i>\n        </div>\n        <div class="bcd-frame">\n          <iframe></iframe>\n        </div>\n      </div>\n    </div>\n  ';
  document.body.appendChild(elDlg);
  elDlg.querySelector('.bcd-close').addEventListener('click', hide);
  elDlg.querySelector('iframe').src = frameUrl;

  hideCallback = onHide;
}

function hide() {
  if (!elDlg) {
    return;
  }

  document.body.removeChild(elDlg);
  elDlg = null;

  if (hideCallback) {
    hideCallback();
    hideCallback = null;
  }
}

window.addEventListener('message', function (ev) {
  if (ev.data !== 'hideCustomizeDialog') {
    return;
  }
  hide();
}, false);

var customizeDialog = {
  show: show,
  hide: hide
};

exports['default'] = customizeDialog;
module.exports = exports['default'];